<!-- 修改第三方登录前验证 -->
<template id="modify_third_party">
  <section class="modify-third-party">
    <id_validate :v_type="type" :switch_enabled="false" :btn_text="btnText" :request="request" @next="next" @errorResult="errorResult"></id_validate>
  </section>
</template>

<script>
  import id_validate from './../id_validate.vue'

  export default {
    props: ['info'],
    data() {
      return {
        type: 'phone',
        btnText: '解绑重新验证',
        request: {
          phone: this.info[1].value,
          // hasError: false
        }
      }
    },
    methods: {
      next() {
        this.$emit('next');
      },
      errorResult(response) {
        this.$emit('errorResult', response);
      }
    },
    components: {
      id_validate
    }
  }
</script>

<style media="screen" scoped lang="scss">
  .modify-third-party{
    width: 810px;
    padding-top: 70px;
  }
</style>



// WEBPACK FOOTER //
// modify_third_party.vue?62c416c6